import { SxProps, Theme } from '@mui/material';

type TStyles = {
  accordion: SxProps<Theme>;
  summary: SxProps<Theme>;
  summaryContent: SxProps<Theme>;
  title: SxProps<Theme>;
  description: SxProps<Theme>;
  expandIcon: SxProps<Theme>;
  details: SxProps<Theme>;
  list: SxProps<Theme>;
  listItem: SxProps<Theme>;
  itemText: SxProps<Theme>;
  itemTitle: SxProps<Theme>;
  itemDescription: SxProps<Theme>;
};

export const expandableInfoCardStyles: TStyles = {
  accordion: (theme: Theme) => ({
    boxShadow: 'none',
    backgroundColor: '#fff',
    width: '700px',
    padding: theme.spacing(3.125),
    marginBottom: theme.spacing(1.5),
    borderRadius: '15px !important',
    overflow: 'hidden',
    boxSizing: 'border-box',
    [theme.breakpoints.down(800)]: {
      width: '550px',
    },
    [theme.breakpoints.down(600)]: {
      width: '95%',
    },
    '&:before': {
      display: 'none',
    },
  }),
  summary: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'unset',
    px: 0,
    py: 0,
    '& .MuiAccordionSummary-content': {
      display: 'block',
      margin: 0,
      width: '100%',
    },
    '&.Mui-expanded': {
      minHeight: 'unset',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      margin: 0,
      color: theme.palette.common.black,
      transition: 'transform 0.3s ease',
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(180deg)',
    },
  }),
  summaryContent: (theme: Theme) => ({
    width: '100%',
    textAlign: 'center',
    paddingBottom: theme.spacing(0.5),
  }),
  title: (theme: Theme) => ({
    fontSize: '22px',
    fontWeight: 700,
    color: 'inherit',
    margin: 0,
    marginBottom: theme.spacing(1.25),
  }),
  description: {
    fontWeight: 600,
    fontSize: '13px',
    margin: 0,
  },
  expandIcon: (theme: Theme) => ({
    width: '50px',
    height: '50px',
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  }),
  details: (theme: Theme) => ({
    p: 0,
    backgroundColor: '#fff',
    mt: theme.spacing(0.5),
  }),
  list: (theme: Theme) => ({
    listStyle: 'none',
    counterReset: 'benefits-counter',
    m: 0,
    p: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down(700)]: {
      gridTemplateColumns: '1fr',
    },
  }),
  listItem: (theme: Theme) => ({
    counterIncrement: 'benefits-counter',
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    p: 0,
    '&::before': {
      content: 'counter(benefits-counter) "."',
      color: theme.palette.primary.dark,
      fontSize: '15px',
      fontWeight: 600,
      lineHeight: 1.3,
      flexShrink: 0,
    },
  }),
  itemText: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    m: 0,
  }),
  itemTitle: (theme: Theme) => ({
    color: theme.palette.primary.dark,
    fontSize: '15px',
    fontWeight: 700,
    lineHeight: 1.3,
    [theme.breakpoints.down(700)]: {
      fontSize: '15px',
    },
  }),
  itemDescription: (theme: Theme) => ({
    fontSize: '13px',
    lineHeight: 1.45,
    [theme.breakpoints.down(700)]: {
      fontSize: '12px',
    },
  }),
};
